import { FlyoutMenu, SvgIcon } from '@bob/library'
import { WithBrand } from '@websrc/App/Components/WithBrand'
import { useStaticText } from '@websrc/App/Hooks/useStaticText'
import { mapTeacherHubProducts } from '@websrc/DataMappers/mapTeacherHubProducts'
import clsx from 'clsx'
import { box, rule, styles, typography } from 'leds'
import React, { FC, Fragment } from 'react'

import { SidebarProductMenuItem } from './SidebarProductMenuItem'

export type SidebarProductProps = {
  label: string
  products: ReturnType<typeof mapTeacherHubProducts>
}

export const SidebarProduct: FC<SidebarProductProps> = ({ products, label }) => {
  const t = useStaticText()

  return (
    <div className={styles({ padding: 16 })}>
      <p className={clsx(styles({ marginBottom: 8 }), typography({ size: 'md' }))}>
        {t.teacher_support.choose_your_product}
      </p>
      <FlyoutMenu
        buttonElement={
          <div
            className={clsx(
              styles({
                cursor: 'pointer',
                padding: 16,
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
              }),
              box({ borderColor: 'grey5', border: 'full' })
            )}
            tabIndex={0}
          >
            <div
              className={styles({
                display: 'flex',
                flexDirection: 'column',
                marginRight: 10,
                whiteSpace: 'normal',
              })}
            >
              <span className={typography({ size: 'xs', color: 'grey' })}>
                <WithBrand title={'{brand}'} />
              </span>
              <span>{label}</span>
            </div>
            <SvgIcon name={'ARROW_DOWN'} size={14} strokeWidth={3} />
          </div>
        }
        className={styles({ background: 'white' })}
      >
        <div className={styles({ padding: 16 })}>
          {products.map((product, key) => (
            <Fragment key={key}>
              {key !== 0 && (
                <hr
                  className={rule({ direction: 'horizontal', background: 'grey5' })}
                  data-testid={'product-separator'}
                />
              )}
              <SidebarProductMenuItem product={product} />
            </Fragment>
          ))}
        </div>
      </FlyoutMenu>
    </div>
  )
}
